import get from 'lodash/get';
import { getDocumentFields, getFileUrl } from 'utils/helper';

export const getFeaturedProjectProps = (data) => {
  const {
    title,
    description,
    images,
  } = getDocumentFields(
    data,
    [
      'title',
      'description',
      'images',
    ],
  );
  const imageUrl = getFileUrl(get(images, '[0]'));

  return {
    projectTitle: title,
    imageUrl,
    projectLink: description,
  };
};
